import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as _R from 'ramda';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import {DialogBoxMedium} from '../../../common/dialog.medium';
import { CustomDatePicker } from '../../../common/CustomDatePicker';

export const MaritalStatusComponent = (props) => {
    const { EditPermission, DeletePermission, maritalDetails, onAdd, onUpdate, onDeleteSubmit } = props;
    let data = (_R.type(maritalDetails) !== 'undefined') ? maritalDetails : {};
    let Edit = EditPermission;
    let Delete = DeletePermission;
    return (        
        <>    
            <div className={'listSubHeader'}>
                <Typography component="h2" className={'section-title'} variant="button" display="block" gutterBottom color="primary">Marital Status</Typography>
                {_R.equals(Edit, true) &&
                <Tooltip title="Add Marital Status" aria-label="add">
                    <Fab size="small" color="default" aria-label="add" className={'fab-outline'} onClick={onAdd}>
                        <AddIcon />
                    </Fab>
                </Tooltip>
                }
            </div> 
            <div className={'section-content'}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                            <TableCell>Marital Status</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { typeof data != 'undefined' && data.length
                            ? data.map( (m, index ) =>
                        <TableRow>
                            <TableCell>{m.start_date}</TableCell>
                            <TableCell>{m.end_date}</TableCell>
                            <TableCell>{m.title}</TableCell>
                            <TableCell align="right">
                            {_R.equals(Edit, true) &&
                                <Tooltip title="Edit" aria-label="edit">
                                    <IconButton   className={'action-btn'} edge="end" aria-label="Comments">
                                        <EditIcon fontSize="small" onClick={onUpdate(m.id)}/>
                                    </IconButton>
                                </Tooltip>
                            }
                            {_R.equals(Delete, true) &&
                                <Tooltip title="Delete" aria-label="delete">
                                    <IconButton  className={'action-btn'} edge="end" aria-label="Comments">
                                        <DeleteIcon fontSize="small" onClick={onDeleteSubmit(m.id)}/>
                                    </IconButton>
                                </Tooltip>
                            }
                            </TableCell>
                        </TableRow>
                        )
                        :<></> }
                    </TableBody>
                </Table>
            </div>
            <DialogBoxMedium 
                Open= { props.open }  
                Cancel = { props.onClose }
                Title = { props.IsEditable ? 'Edit Marital Details' : 'Add Marital Details' }
                OnSubmit = { props.OnSubmit }
                Content = { <DialogContent FormProps={props}/> }/>
        </>
    )
};

const DialogContent = (p) => {
    const {FormProps:props} = p;
    const {FormFields, FormInputs, HandleOnChange, HandleDateChange } = props;
    return (
        <form className="form-fullwidth" onSubmit={props.OnSubmit}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <FormControl>
                        <CustomDatePicker
                            name = "start_date"
                            id = "start_date"
                            selectedDate = {FormFields.start_date}
                            handleDateChange = {HandleDateChange}
                            error = {props.Errors.start_date}
                            required = {true}
                            label = "Start Date"
                        />
                    </ FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl>
                        <CustomDatePicker
                            name = "end_date"
                            id = "end_date"
                            selectedDate = {FormFields.end_date}
                            handleDateChange = {HandleDateChange}
                            error = {props.Errors.end_date}
                            label = "End Date"
                        />
                    </ FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl variant="standard">
                        <InputLabel required error = {props.Errors.marital_status} htmlFor="status">Marital Status</InputLabel>
                        <Select
                            value={_R.type(FormFields) !== 'Undefined' && FormFields.status}
                            onChange={HandleOnChange}
                            inputProps={{
                                name: 'status',
                                id: 'status',
                            }}>
                            {_R.type(FormInputs) === 'Object' && _R.type(FormInputs.marital_statuses) !== 'Undefined' && FormInputs.marital_statuses.map((t, i) =>            
                                <MenuItem value={t.id} key={'sub-type-'+i}>{t.title}</MenuItem>
                            )}
                        </Select>
                        {props.Errors.marital_status && <FormHelperText className='error'>{props.Errors.marital_status}</FormHelperText> }
                    </ FormControl>
                </Grid>   
            </Grid>
        </form>
    )
}
